import { render, staticRenderFns } from "./DeclineReasonModal.vue?vue&type=template&id=2df45bfd&scoped=true&"
import script from "./DeclineReasonModal.vue?vue&type=script&lang=ts&"
export * from "./DeclineReasonModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeclineReasonModal.vue?vue&type=style&index=0&id=2df45bfd&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df45bfd",
  null
  
)

export default component.exports